// ============================================================
//  ContestGo.js — short invite link  /r/:code  → opens WhatsApp with the message + code
// ============================================================
import './ContestPublic.css';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { resolveInvite } from '../contact-saver/contestApi';

export default function ContestGo() {
  const { code } = useParams();
  const [d, setD] = useState(null);
  const [err, setErr] = useState('');

  useEffect(() => {
    resolveInvite(code).then(r => {
      if (!r.success) { setErr(r.message || 'This invite link isn’t valid.'); return; }
      setD(r);
      document.title = r.contest.name;
      if (r.state === 'live' || r.state === 'scheduled') window.location.replace(r.waLink);
    }).catch(() => setErr('Couldn’t open the invite. Check your connection.'));
  }, [code]);

  if (err) return <main className="cpj cpj-center"><p>{err}</p></main>;
  if (!d) return <main className="cpj cpj-center"><span className="cpj-spin" aria-label="Opening WhatsApp" /></main>;
  const over = d.state === 'ended' || d.state === 'paused';
  return (
    <main className="cpj cpj-center">
      <div className="cpj-go-box">
        <h1>{d.contest.name}</h1>
        <p>{over ? `This contest is ${d.state === 'ended' ? 'over' : 'paused'}, so this invite won’t count — but you can still say hi.` : `${d.by} invited you. Opening WhatsApp…`}</p>
        <a className="cpj-go" href={d.waLink}>{over ? 'Message on WhatsApp' : 'Open WhatsApp'}</a>
        {!over && <small>Just tap send when WhatsApp opens — keep the code in the message.</small>}
        <a className="cpj-link-btn" href={`/c/${d.contest.slug}`}>Join the contest yourself</a>
      </div>
    </main>
  );
}
